import React from 'react';
import clsx from 'clsx';

var ProgressBar = function (_a) {
    var _b = _a.progress, progress = _b === void 0 ? 1 : _b, className = _a.className;
    var style = {
        width: "".concat(progress, "%")
    };
    return (React.createElement("div", { "data-testid": 'progress-bar', className: clsx('c-uploader__progress-bar', className) },
        React.createElement("div", { style: style, className: 'c-uploader__progress-bar-indicator' })));
};

export { ProgressBar as default };
//# sourceMappingURL=ProgressBar.js.map
